import { useSyncExternalStore } from 'react';

/** Mano con la que lanzas (Ajustes). Se envía con cada input; el servidor la aplica antes de cada lanzamiento. */
const KEY = 'sportsarena.throwHand';
let hand: 'R' | 'L' = (() => {
  try {
    return typeof window !== 'undefined' && localStorage.getItem(KEY) === 'L' ? 'L' : 'R';
  } catch {
    return 'R';
  }
})();
const listeners = new Set<() => void>();
export const getThrowHand = (): 'R' | 'L' => hand;
export const setThrowHand = (v: 'R' | 'L'): void => {
  hand = v;
  try {
    localStorage.setItem(KEY, v);
  } catch {
    /* sin almacenamiento */
  }
  listeners.forEach((l) => l());
};
export const useThrowHand = (): 'R' | 'L' =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getThrowHand,
    getThrowHand
  );
